import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import GlobalStyles from './styles/GlobalStyles';

// Pages
import Home from './pages/Home';
import DJServices from './pages/DJServices';
import LightingProduction from './pages/LightingProduction';
import VinylSales from './pages/VinylSales';
import KeenAcousticSciences from './pages/KeenAcousticSciences';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <GlobalStyles />
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/dj-services" element={<DJServices />} />
          <Route path="/lighting-production" element={<LightingProduction />} />
          <Route path="/vinyl-sales" element={<VinylSales />} />
          <Route path="/keen-acoustic-sciences" element={<KeenAcousticSciences />} />
        </Routes>
        <Footer />
      </Router>
    </HelmetProvider>
  );
}

export default App; 